export const EnIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="en-circle-clip">
          <circle cx="20" cy="20" r="14.375" />
        </clipPath>
      </defs>
      <g clipPath="url(#en-circle-clip)">
        <rect x="5.625" y="5.625" width="28.75" height="28.75" fill="#012169" />
        <line x1="5.625" y1="5.625" x2="34.375" y2="34.375" stroke="white" strokeWidth="4.5" />
        <line x1="34.375" y1="5.625" x2="5.625" y2="34.375" stroke="white" strokeWidth="4.5" />
        <line x1="5.625" y1="5.625" x2="34.375" y2="34.375" stroke="#C8102E" strokeWidth="2.5" />
        <line x1="34.375" y1="5.625" x2="5.625" y2="34.375" stroke="#C8102E" strokeWidth="2.5" />
        <rect x="5.625" y="17.5" width="28.75" height="5" fill="white" />
        <rect x="17.5" y="5.625" width="5" height="28.75" fill="white" />
        <rect x="5.625" y="18.5" width="28.75" height="3" fill="#C8102E" />
        <rect x="18.5" y="5.625" width="3" height="28.75" fill="#C8102E" />
      </g>
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#6AA543" />
    </svg>
  );
};
